import React, { useEffect, useState } from 'react';
import { Panel, Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
  getDashboardLink,
} from '../../features/app/appSlice';
import { getDocumentId } from '../../features/dashboard/dashboardSlice';
import { getApplicationClaim } from '../../firebase';
import { useSetReduxState } from '../../hooks/useResetReduxState';
import useTitle from '../../hooks/useTitle';

const ChallengeSubmitted = () => {
  const [setResetReduxState] = useSetReduxState();
  const dashboardLink = useSelector(getDashboardLink);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  const [claimData, setClaimData] = useState({});
  const documentId = useSelector(getDocumentId);

  useTitle(
    'landlordReg.ChallengeSubmitted.s9',
    'Challenge submitted - OZEV Electric Vehicle Chargepoint Grants - GOV.UK'
  );

  useEffect(() => {
    if (dashboardLink) {
      getApplicationClaim({ id: documentId }).then((response) => {
        const { data } = response;
        setClaimData(data);
      });
    }
  }, [documentId, dashboardLink]);

  const handleButton = () => {
    setResetReduxState('pmcJourney', 'applicationJourney');
    window.location.assign(dashboardLink);
  };

  const bannerTitle = copyProvider.getCopy(
    'landlordReg.ChallengeSubmitted.s1',
    'Challenge submitted'
  );
  const bannerSubHeading = copyProvider.getCopy(
    'landlordReg.ChallengeSubmitted.s2',
    'Your reference number'
  );
  const firstParagragh = copyProvider.getCopy(
    'landlordReg.ChallengeSubmitted.s3',
    'Thank you for submitting your challenge to us.'
  );
  const subHeading = copyProvider.getCopy(
    'landlordReg.ChallengeSubmitted.s4',
    'What happens next'
  );
  const secondParagragh = copyProvider.getCopy(
    'landlordReg.ChallengeSubmitted.s5',
    'We will review the details you sent us. We will contact you if we need more information about what happened.'
  );
  const linkText = copyProvider.getCopy(
    'landlordReg.ChallengeSubmitted.s6',
    'What did you think of this service?'
  );
  const textAfterLink = copyProvider.getCopy(
    'landlordReg.ChallengeSubmitted.s7',
    ' (takes 30 seconds)'
  );

  const pageModel = (
    <>
      <Panel titleChildren={bannerTitle}>
        {bannerSubHeading} {claimData.claim_id}
      </Panel>
      <p className="govuk-body">{firstParagragh}</p>
      <h2 className="govuk-heading-m">{subHeading}</h2>
      <p className="govuk-body">{secondParagragh}</p>
      <p className="govuk-body govuk-!-padding-top-4">
        <a
          href="https://www.smartsurvey.co.uk/s/EV-grants/"
          className="govuk-link"
          target="_blank"
          rel="noreferrer"
        >
          {linkText}
        </a>
        {textAfterLink}
      </p>
      <Button
        className="govuk-button govuk-!-margin-top-4"
        onClick={handleButton}
      >
        {copyProvider.getCopy(
          'landlordReg.ChallengeSubmitted.s8',
          'Manage your applications'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default ChallengeSubmitted;
